const APIS = {
  STAFF: "logisticservice/api//staff/",
  WEBSITE: "/get-website/",
  DISPATCH_MANIFEST: "/manifestservice/api/manifest/dispatch-manifest/",
  RECEIVE_MANIFEST: "/manifestservice/api/manifest/receive-manifest/",
  RUNSHEET: "/runsheetservice/api/runsheet/",
  RTV_ORDER: "/rtvorderservice/api/rtv-order/",
  RTV_BRANCH: "/rtvorderservice/api/rtv-branch-order/",
  PICKUP_REQUEST: "/pickuprequestservice/api/pickup-request/",
  VEHICLE_MANIFEST: "/vehiclemanifestservice/api/vehicle-manifest/",
  MERCHANT_INVOICE: "/invoiceservice/api/merchant-invoice/",
  BRANCH_INVOICE: "/invoiceservice/api/branch-invoice/",
  RIDER_INVOICE: "/invoiceservice/api/rider-invoice/",
  USER: "usermanagementservice/api/user/",
  // USER_PROFILE: "logisticservice/api/user-profile/",
  CLIENT_TYPE: "logisticservice/api/client-type/",
  ORDER: "/logisticservice/api/order/",
  WEBSITE_INFO: "websiteservice/api/basic-website-info/",
  CLIENT_SETTING: "/projectsettingsservice/api/configuration/",
  NOTIFICATION: "notificationservice/api/notification/",
  FILE_HANDLER: "/driveservice/api/file/",
  BRANCH: "/usermanagementservice/api/branch/",
  AVAILABLE_SERVICE: "/service-list/",
  COMMENT: "/commentservice/api/comment/",
  REFRESH_TOKEN: "/usermanagementservice/api/refresh-token/",
  RECORD_NOTICE: "/alertpopupservice/api/notice-record/",
  ACTIVE_NOTICE: "/alertpopupservice/api/notice/active/",
  NOTICE: "/alertpopupservice/api/notice/",
  ORDER_HISTORY: "/historyservice/api/history/",
  RUNSHEET_ORDER: "/runsheetservice/api/runsheet/order-runsheet/",
  INVOICE: "/invoiceservice/api/merchant-invoice/invoice-id/",
  RECEIVER_DETAIL: "/logisticservice/api/receiver-detail/",
  SUPPORT: "/ticket/",
  SIDEBAR: "/service-list/sidebar/",
  LOGOUT: "/usermanagementservice/api/user/logout/",
  COMPANY: "/usermanagementservice/api/company/",
  PUSH_NOTIFICATION: "/pushnotificationservice/api/webpush-devices/",
  TICKET: "/helpdeskservice/api/ticket/",
  TICKET_QUEUE: "/helpdeskservice/api/queue/",
  GROUP: "/chatservice/api/group/",
  MESSAGE: "/chatservice/api/message/",
  UPDATE_FOLLOW: "logisticservice/api/order/update-last-follow/",
  TABLE_SETTINGS: "/projectsettingsservice/api/column-definition/",
  GENERATE_QR: "/driveservice/api/generate-qr/",
  BANK_DETAIL: "/usermanagementservice/api/bank-detail/",
  ORGANIZATION: "/usermanagementservice/api/organization/",
};

export default APIS;
